// @ts-check
import {Modal, Text, TextInput, Toggle} from '@/components-v2'
import {useComboSetupSection} from '@/hooks/productCombo/useComboSetupSection'
import {MODAL_TYPE} from '@/utils/constants/globalStyle'

export const ComboSetupSection = () => {
  const {
    name,
    active,
    comboLimitInput,
    comboLimitError,
    hasComboLimitValue,
    errors,
    showInvalidStatusModal,
    handleComboLimitChange,
    updateActiveStatus,
    handleCloseModal,
    updateProductCombo,
  } = useComboSetupSection()

  return (
    <div className="flex flex-col gap-6 rounded-lg bg-[var(--color-background-layer-01)] p-6">
      <Text variant="bold">Combo Setup</Text>
      <div className="flex gap-6">
        <TextInput
          label="Combo Name*"
          value={name}
          onUpdate={value => updateProductCombo({name: value})}
          error={name ? errors.name : undefined}
          placeholderText="Product Combo Name"
          className="w-[350px]"
        />
        <TextInput
          label="Combo Limit*"
          value={comboLimitInput}
          onUpdate={handleComboLimitChange}
          error={comboLimitError || (!comboLimitInput && hasComboLimitValue ? errors.comboLimit : undefined)}
          placeholderText="Combo Limit"
          className="w-[350px]"
        />
      </div>
      <div className="h-px bg-[var(--secondary-800)]" />
      <Text variant="bold">Availablity</Text>
      <Toggle checked={active} onUpdate={updateActiveStatus} size="small" label="Active" />
      <Modal
        type={MODAL_TYPE.SMALL}
        showModal={showInvalidStatusModal}
        title="This combo product has one or more inactive products associated to it."
        showPrimaryButton
        primaryButtonProps={{text: 'Ok', onClick: handleCloseModal}}
        className="min-h-80"
        hideCloseButton={true}
      />
    </div>
  )
}
